/**
 * @generated SignedSource<<30bdc9fef7e1a7e62aaf5252e51c5c11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PerformanceOverviewNumbers_data$data = {
  readonly currentbenchmarktext: string | null | undefined;
  readonly currentperformancetext: string | null | undefined;
  readonly pabenchmarktext: string | null | undefined;
  readonly paperformancetext: string | null | undefined;
  readonly " $fragmentType": "PerformanceOverviewNumbers_data";
};
export type PerformanceOverviewNumbers_data$key = {
  readonly " $data"?: PerformanceOverviewNumbers_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PerformanceOverviewNumbers_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PerformanceOverviewNumbers_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentperformancetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentbenchmarktext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paperformancetext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pabenchmarktext",
      "storageKey": null
    }
  ],
  "type": "PerformanceOverviewInfo",
  "abstractKey": null
};

(node as any).hash = "5bf3a61924c83d03148b13d216b9a6e2";

export default node;
